import { Link, useParams } from "react-router-dom";
import FastForm from "../../components/FastForm/FastForm";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import useUsers from "../../hooks/useUsers";
import { useMemo, useState } from "react";
import FastTable, { TABLE_TYPES } from "../../components/FastTable/FastTable";
import { usePage } from "../../hooks/usePage";
import useEvents from "../../hooks/useEvents";
import useLang from "../../lang/useLang";
import useReports from "../../hooks/useReports";
import UserTransactions from "../../components/user/UserTransactions";
import UserNFCData from "../../components/user/UserNFCData";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function SearchUser() {
  const { trans } = useLang();
  const params = useParams();
  const [filter, setFilter] = useState({});
  const { editUser, ...usersQuery } = useUsers({
    offset: 0,
    limit: 1000000,
    filter: filter,
    enabled: Object.keys(filter).length > 0,
  });
  usePage({ title: "Buscar usuario" });

  const { data: events } = useEvents({ offset: 0, limit: 1000000 });
  const [userResultIndex] = useState(0);

  const isQueryEmpty = Object.keys(filter).length === 0;

  const fakeMutation = useMemo(
    () => ({
      mutate: (data) => {
        console.log(Object.keys(data));
        console.log(Object.keys(data).filter((key) => data[key] !== ""));
        console.log(
          Object.keys(data)
            .filter((key) => data[key] !== "")
            .reduce((acc, key) => ({ ...acc, [key]: data[key] }), {})
        );
        const filterKeys = Object.keys(data).filter((key) => data[key] !== "");
        const reducedFilter = filterKeys.reduce(
          (acc, key) => ({ ...acc, [key]: data[key] }),
          {}
        );
        setFilter(reducedFilter);
      },
      ...usersQuery,
    }),
    [usersQuery]
  );

  const user = useMemo(() => {
    if (usersQuery?.data?.length > userResultIndex) {
      return usersQuery.data[userResultIndex];
    }
    return null;
  }, [usersQuery.data, userResultIndex]);

  const reports = useReports({
    eventid: params.eventid,
    limit: 10000000,
    offset: 0,
    start: 1,
    tag: user?.tag
  });

  const txs = useMemo(() => {
    if (reports.parsedData && user?.tag) {
      return reports.parsedData.filter((tx) => tx.tag === user.tag);
    }
    return [];
  }, [reports.parsedData, user?.tag]);

  return (
    <Container fluid>
      <Row>
        <Col>
          <h1>Buscar usuario</h1>
          <hr className="small" />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <h2>Buscar usuario</h2>
          <FastForm
            mutation={fakeMutation}
            sendText="Buscar"
            fields={[
              {
                name: "name",
                label: "Nombre",
                placeholder: "Nombre",
                type: "text",
              },
              {
                name: "email",
                label: "Email",
                placeholder: "Email",
                type: "email",
              },
              {
                name: "tag",
                label: "Tag",
                placeholder: "Tag",
                type: "text",
              },
              // {
              //   name: "orgid",
              //   label: "Organización",
              //   placeholder: "Organización",
              //   type: "hidden",
              //   attributes: { readOnly: true },
              //   defaultValue: user.orgid,
              // },
            ]}
          />
        </Col>
        {usersQuery.data && usersQuery.data?.length > 0 ? (
          <Col lg={9}>
            <h2>Usuario{usersQuery.data?.length > 1 ? "s" : ""}</h2>
            {usersQuery.isLoading && <Spinner animation="border" />}
            {usersQuery.data?.length > 0 && (
              <FastTable
                data={usersQuery.data}
                showExcel={false}
                showGroups={false}
                showFilters={false}
                columns={[
                  { key: "userid", label: "userid", type: TABLE_TYPES.string },
                  { key: "name", label: "name", type: TABLE_TYPES.string },
                  { key: "email", label: "email", type: TABLE_TYPES.string },
                  { key: "tag", label: "tag", type: TABLE_TYPES.string },
                  { key: "shortag", label: "shortag", type: TABLE_TYPES.string },
                  {
                    key: "repair", label: "Reparar", type: TABLE_TYPES.string,
                    render: (row) => (
                      <input type="checkbox" checked={row?.repair === "1"} onChange={() => {
                        editUser({ ...row, repair: row?.repair === "1" ? "0" : "1" });
                      }} />
                    )
                  },
                  {
                    key: "block", label: "Bloquear", type: TABLE_TYPES.string,
                    render: (row) => (
                      <input type="checkbox" checked={row?.block === "1"} onChange={() => {
                        editUser({ ...row, block: row?.block === "1" ? "0" : "1" });
                      }} />
                    )
                  },
                  {
                    key: "eventid",
                    label: "Evento",
                    type: TABLE_TYPES.options,
                    options: [
                      {
                        value: "0",
                        label: trans("devices.chooseevent"),
                      },
                      ...(events || []).map((event) => ({
                        value: event.eventid,
                        label: event.name,
                      })),
                    ],
                  },
                  {
                    key: "edit",
                    label: "Editar",
                    render: (row) => (
                      <Link to={`/${params.eventid}/users/${row.userid}`} style={{ textAlign: "center", display: "block" }}>
                        <FontAwesomeIcon icon={faEdit} />
                      </Link>
                    ),
                  }
                ]}
              />
            )}
            {usersQuery.data?.length === 1 && (<>
              <hr />
              <UserNFCData basicUser={user} txs={txs} />
              <hr />
              <UserTransactions txs={txs} eventid={params.eventid} />
            </>)}
          </Col>
        ) : (
          <Col md={9}>
            {isQueryEmpty ?
              (
                <p>Ingresá email, tag o nombre para buscar un usuario</p>
              ) : (
                usersQuery.isLoading ? (
                  <Spinner animation="border" />
                ) : (
                  usersQuery.data?.length === 0 && <p>No se encontraron resultados</p>
                )
              )}
          </Col>
        )}
      </Row>
    </Container >
  );
}
